export default {
  LOGINUSERDATA: "LOGINUSERDATA",
  SPECIFICUSERDETAIL: 'SPECIFICUSERDETAIL'
};
